import React, { useState } from 'react'
import { format } from 'date-fns'
import { Link } from 'react-router-dom'

const ViewBooking = ({ _booking, booking, uid, _converteTimeToHours, state }) => {
    const [currentDate, setCurrentDate] = useState(format(new Date(Date.now()), 'MM/dd/yyyy'))
    const [bookingHistory, setBookingHistory] = useState(false) 

    return (
        <div>

            {/* HISTORIQUE DES RESERVATIONS */}
            <div className='row shadow mt-3'>
                <div className='card-body'>
                    
                    <div className='row' onClick={() => setBookingHistory(!bookingHistory)}>
                        <div className='col-1'></div> 
                        <div className='col text-center'>Historique des réservations</div>
                        <div className='col-1 text-end'>
                            <i className={bookingHistory === true ? "bi bi-chevron-compact-up" : "bi bi-chevron-compact-down"}></i>
                        </div>
                    </div>
                </div> 
                {bookingHistory && 
                    <>
                        <div className='row border-top mt-1 border-end'></div>
                        {/* HISTORIQUE DES RESERVATIONS */}
                        <div className='shadow row'>
                            {booking.filter(b => b.uidClient === uid && b.date >= currentDate && b.cancel === true).map(b => (
                                // CARD MES RENDEZ-VOUS
                                <div className='mt-2 border-bottom row' key={b.id}>
                                    <div className='pt-2 pb-3'>{b.dateShow} à {_converteTimeToHours(b.hours)} : {b.nameService} {b.priceService}€  - {b.durationService}min <span className='text-danger'>Annulée</span></div>
                                </div>
                            ))}
                            {booking.filter(b => b.uidClient === uid && b.date < currentDate).map(b => (
                                // CARD MES RENDEZ-VOUS
                                <div className='mt-2 border-bottom row' key={b.id}>
                                    <div className='pt-2 pb-3'>{b.dateShow} à {_converteTimeToHours(b.hours)} : {b.nameService} {b.priceService}€  - {b.durationService}min <span className='text-danger'>Annulée</span></div>
                                </div>
                            ))}
                        </div>
                    </>
                }

            </div>
        </div>
    )
}

export default ViewBooking



